<template>
    <div class="container">


        <div class="login-box">
            <div class="header">
            占座宝报表二级平台
        </div>

            <van-field v-model="username" required label-width="50px" label="用户名" />
            <van-field type="password" required label-width="50px" v-model="password" label="密码" />
            <div class="btn">
                <van-button type="primary" @click="handlerLogin" block>登陆</van-button>

            </div>
        </div>
    </div>
</template>

<script>
import AdminToken from "../common/AdminToken";
export default {
    name: "Login",
    data(){
        return {
            username: "",
            password: ""
        }
    },
    methods: {
        handlerLogin(){
            if(!this.username || !this.password){
                this.$notify({message: "用户名或者密码为空"})
            }
            this.$http.post("/login", {username: this.username, password: this.password}).then(res =>{
                if(!res) return;
                console.log(res);
                var adminToken = new AdminToken();
                adminToken.setToken(res.data);
                this.$notify({
                    type: "success",
                    message: "登陆成功"
                })
                this.$router.push({name: "index"});
            });
        }
    }
}
</script>

<style scoped>
    .container{
        /*display: flex;*/
        padding: 20px;
        padding-top: 200px;
        background-color: #eee;
        height: 100%;
    }
    .header{
        text-align: center;
        font-size: 18px;
        width: 100%;
        color: #1893ff;
        margin-bottom: 20px;
        padding-top: 20px;
    }
    .login-box{
        padding: 10px 20px;
        background-color: #fff;
        border-radius: 20px;
    }
    .btn{
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue